export default "__VITE_ASSET__BEHD29t0__"